/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { Mail } from "lucide-react";
import TextInput from "../ui/TextInput";
import { useForm, SubmitHandler } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { Link, useNavigate } from "react-router-dom";
import Button from "../ui/Button";
import AuthPageWrapper from "./AuthPageWrapper";
import { forgotPasswordSchema } from "./auth_schemas"; // Schema for validation
import { ForgotPasswordFormInputs } from "./auth_types"; // Type for form inputs
import axiosInstance from "../../apis/baseUrl";
import { toast } from "react-toastify";
import { useAppDispatch } from "../../redux/app/hooks";
import { updateUnAuthorizedForgotPassword } from "../../redux/features/authSlice";

const ForgotPasswordPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<ForgotPasswordFormInputs>({
    resolver: yupResolver(forgotPasswordSchema),
  });

  const handleSendOTP = async (data: any) => {
    try {
      const response: any = await axiosInstance.post(
        "v1/auth/send_reset_password",
        data
      );

      if (response?.data) {
        toast.success(response?.data?.message);
        dispatch(
          updateUnAuthorizedForgotPassword({
            name: "email",
            value: data?.email,
          })
        );
         dispatch(
           updateUnAuthorizedForgotPassword({
             name: "hash",
             value: response?.data?.data,
           })
         );
        navigate("/forgot-password/verify-otp");
        setLoading(false);
      } else {
        console.error("Failed to send OTP");
        setLoading(false);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      setLoading(false);
    }
  };

  const onSubmit: SubmitHandler<ForgotPasswordFormInputs> = (data) => {
    setLoading(true);
    handleSendOTP(data);
  };

  return (
    <AuthPageWrapper
      title="Forgot password"
      sub_title="Enter your email to receive an OTP"
    >
      <form
        className="space-y-4 w-full md:w-[450px]"
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextInput
          id="email"
          type="email"
          label="Email Address"
          placeholder="Enter your email"
          icon={<Mail className="w-5 h-5 text-gray-400" />}
          error={errors.email?.message}
          register={register("email")}
        />
        <Button label="Send OTP" type="submit" isLoading={loading} />
      </form>

      <p className="text-sm text-gray-500 mt-6 text-center">
        Remember your password?{" "}
        <Link to="/" className="text-accent hover:underline">
          Sign in
        </Link>
      </p>
    </AuthPageWrapper>
  );
};

export default ForgotPasswordPage;
